import React from "react";
import { TEAL, STEPS } from "./constant";
import { useT } from "providers/I18nProvider";

/** Section "Bắt đầu chỉ với 4 bước" */
const Steps: React.FC = () => {
  const t = useT();
  return (
    <section className="bg-[#f7fdfd] border-y border-[#d8f3f2]">
      <div className="container mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="text-center max-w-[620px] mx-auto">
          <h2 className="text-[26px] md:text-[32px] font-extrabold text-black01">
            {t("partner.stepsTitlePrefix")}{" "}
            <span style={{ color: TEAL }}>{t("partner.stepsTitleHighlight")}</span>
          </h2>
          <p className="text-gray-600 mt-2">{t("partner.stepsDesc")}</p>
        </div>
        <div className="mt-6 md:mt-9 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {STEPS.map((s) => (
            <div
              key={s.n}
              className="h-full flex flex-col rounded-2xl bg-white p-6 border border-[#d8f3f2]"
            >
              <div
                className="w-10 h-10 rounded-full text-white font-extrabold grid place-items-center"
                style={{ background: TEAL }}
              >
                {s.n}
              </div>
              <h3 className="mt-4 font-extrabold text-black01">{t(s.titleKey)}</h3>
              <p className="text-sm text-gray-600 mt-1 leading-relaxed !mb-0">{t(s.descKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Steps;
